import paginationSelectors from 'modules/shared/pagination/paginationSelectors';
export default paginationSelectors('iam.list.users');
